var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTumblr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25 3C9.25 2.58579 9.58579 2.25 10 2.25H14C14.4142 2.25 14.75 2.58579 14.75 3V6.25H18C18.4142 6.25 18.75 6.58579 18.75 7V11C18.75 11.4142 18.4142 11.75 18 11.75H14.75V16.25H18C18.4142 16.25 18.75 16.5858 18.75 17V21C18.75 21.4142 18.4142 21.75 18 21.75H14C12.7402 21.75 11.532 21.2496 10.6412 20.3588C9.75044 19.468 9.25 18.2598 9.25 17V11.75H6C5.58579 11.75 5.25 11.4142 5.25 11V7C5.25 6.58579 5.58579 6.25 6 6.25H7C7.59674 6.25 8.16903 6.01295 8.59099 5.59099C9.01295 5.16903 9.25 4.59674 9.25 4V3ZM10.75 3.75V4C10.75 4.99456 10.3549 5.94839 9.65165 6.65165C8.94839 7.35491 7.99456 7.75 7 7.75H6.75V10.25H10C10.4142 10.25 10.75 10.5858 10.75 11V17C10.75 17.862 11.0924 18.6886 11.7019 19.2981C12.3114 19.9076 13.138 20.25 14 20.25H17.25V17.75H14C13.5858 17.75 13.25 17.4142 13.25 17V11C13.25 10.5858 13.5858 10.25 14 10.25H17.25V7.75H14C13.5858 7.75 13.25 7.41421 13.25 7V3.75H10.75Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/tumblr.2cfaa8556073150271ba95cdc52e2815.svg";
export { ForwardRef as ReactComponent };